
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Spinner } from '@/components/Spinner';

interface PaymentVerificationProps {
  email: string;
}

const PaymentVerification = ({ email }: PaymentVerificationProps) => {
  return (
    <Card className="w-full max-w-md text-center p-6">
      <CardHeader>
        <CardTitle>Verificando pago</CardTitle>
        <CardDescription>
          Estamos verificando tu pago con Stripe. Por favor, espera un momento...
          {email && (
            <p className="mt-2 text-xs">
              Correo electrónico: <strong>{email}</strong>
            </p>
          )}
        </CardDescription>
      </CardHeader>
      <CardContent className="flex justify-center py-6">
        <Spinner />
      </CardContent>
    </Card>
  );
};

export default PaymentVerification;
